export default "__VITE_ASSET__biRD_4k0__"